module.exports = __webpack_public_path__ + "img/wave.b5c0682.webp";